import httpStore from "@/api/httpStore.js";
import axios from "axios";

export const getSignedUrl = async (type, extension) => {
  return await httpStore
    .post("s3/signed_url", { type, extension })
    .then(res => res.data.url);
};

export const pushFile = async (signedUrl, file, contentType) => {
  return await axios
    .put(signedUrl, file, {
      headers: {
        "Content-type": contentType
      }
    })
    .then(res => res.data);
};
